"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hoverable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var react_1 = require("react");
var Hoverable = function (_a) {
    var children = _a.children, _b = _a.isEnabled, isEnabled = _b === void 0 ? true : _b, onIsHoveringChanged = _a.onIsHoveringChanged, style = _a.style, setIsHoveringFromParent = _a.setIsHoveringFromParent, isHoveringFromParent = _a.isHoveringFromParent;
    var _c = __read((0, react_1.useState)(false), 2), isHoveringHook = _c[0], setIsHoveringHook = _c[1];
    var setIsHovering = setIsHoveringFromParent ? setIsHoveringFromParent : setIsHoveringHook;
    var isHovering = isHoveringFromParent ? isHoveringFromParent : isHoveringHook;
    var updateHovering = function (newIsHovering) {
        if (onIsHoveringChanged && newIsHovering !== isHovering) {
            onIsHoveringChanged(newIsHovering);
        }
        setIsHovering(newIsHovering);
    };
    return ((0, jsx_runtime_1.jsx)("div", { "data-ta-locator": "hoverable", style: style, onMouseEnter: isEnabled ? function () { return updateHovering(true); } : undefined, onMouseLeave: isEnabled ? function () { return updateHovering(false); } : undefined, onTouchStart: isEnabled ? function () { return updateHovering(true); } : undefined, children: children(isHovering) }));
};
exports.Hoverable = Hoverable;
exports.Hoverable.displayName = "Hoverable";
//# sourceMappingURL=Hoverable.js.map